@import '~style-sheet-helpers/core.less';
@import '../../../../../../../constants/spacing.module.less';

.mapping-list-wrapper {
  margin-top: @space-16;
}
